import { Connector, ClientType } from "@domain/connection/models/Connector";
import { ConnectorDTO } from "../dto/MarketplaceDTOs";

export class ConnectorMapper {
    static toModel(dto: ConnectorDTO): Connector {
        return {
            type: dto.type as ClientType,
            image: dto.image,
            sort: dto.sort
        };
    }

    static toDTO(model: Connector): ConnectorDTO {
        return {
            type: model.type,
            image: model.image || '',
            sort: model.sort
        };
    }
}
